
import React from 'react';

// Derive base URL from the running script so logos work on WordPress embeds
const getBaseUrl = () => {
  // In production, find the base from the main JS bundle path
  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length - 1; i >= 0; i--) {
    const src = scripts[i].src;
    if (src && src.includes('/static/js/')) {
      return src.substring(0, src.indexOf('/static/js/'));
    }
  }
  return '.';
};
const BASE_URL = getBaseUrl();

export const Logo = ({ className, darkMode }: { className?: string, darkMode?: boolean }) => {
  const containerClass = className || "h-24 w-auto";
  const src = darkMode
    ? `${BASE_URL}/logodark.svg`
    : `${BASE_URL}/logo.svg`;

  return (
    <div className={`${containerClass} flex items-center justify-start`}>
        <img src={src} alt="RegIQ" className="h-full w-auto object-contain" />
    </div>
  );
};
